import  React, { useState, useContext } from "react";
import { Drawer } from "antd";
import Logo from "./Logo";
import Flex from "../shared-components/Flex";
import { ArrowLeftOutlined } from "@ant-design/icons";
import SiderMenu from '../../components/navMenu/siderMenu'
import { ConstContext } from '../../store/context/constContext'

export const MobileNav = ({
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization = true,
}) => {
    const props = { sideNavTheme, routeInfo, hideGroupTitle, localization };
    const {
        mobileNav,
        setMobileNav
    } = useContext(ConstContext)

    const onClose = () => {
        setMobileNav(false);
    };

    return (
        <Drawer
            placement="left"
            closable={false}
            onClose={onClose}
            visible={mobileNav}
            bodyStyle={{ padding: 5 }}
        >
            <Flex flexDirection="column" className="h-100">
                <Flex justifyContent="between" alignItems="center">
                    <Logo mobileLogo={true} />
                    <div className="nav-close" onClick={() => onClose()}>
                        <ArrowLeftOutlined />
                    </div>
                </Flex>
                <div className="mobile-nav-menu">
                    <SiderMenu />
                </div>
            </Flex>
        </Drawer>
    );
};

export default MobileNav;
